import { FC } from 'react'
import { BaseCardSkeleton } from '@shared/ui/Layout/Cards/BaseCard'

interface Props {
  className?: string
  animate?: boolean
}

const Skeleton: FC<Props> = ({ className = '', animate = true }) => {
  return <BaseCardSkeleton sizes='L ML' className={className} animate={animate} />
}

export default Skeleton
